/*
 * Copyright (c) 2026. Orion Analytics.
 */

import {
    BarChart3,
    Activity,
    Landmark,
    Globe,
    CandlestickChart
} from "lucide-react";

export default function MarketSubNav({
    activeTab,
    setActiveTab
}) {

    const tabs = [

        {
            label: "Market Overview",
            icon: <BarChart3 size={18}/>
        },

        {
            label: "Derivatives Structure",
            icon: <CandlestickChart size={18}/>
        },

        {
            label: "Market Sentiment",
            icon: <Activity size={18}/>
        },

        {
            label: "Global Markets",
            icon: <Globe size={18}/>
        },

        {
            label: "Fixed Income & Macro",
            icon: <Landmark size={18}/>
        }

    ];

    return (

        <div
            className="
          fixed
          top-[130px]
          left-1/2
          -translate-x-1/2
          z-40
          hidden
          lg:flex
        "
        >

            <div
                className="
                    max-w-[1700px]
                    mx-auto
                    px-6
                    lg:px-10
                "
            >

                <div
                    className="
          flex
          items-center
          gap-2

          bg-white/15
          backdrop-blur-xl

          border
          border-white/40

          shadow-[0_8px_32px_rgba(0,0,0,0.10)]

          rounded-2xl

          px-3
          py-3
                    "
                >

                    {tabs.map((tab) => (

                        <button
                            key={tab.label}
                            onClick={() =>
                                setActiveTab(tab.label)
                            }
                            className={`
                                flex
                                items-center
                                gap-2
                                whitespace-nowrap
                                px-5
                                py-3
                                rounded-xl
                                text-sm
                                font-semibold
                                transition-all
                                duration-200

                                ${
                                    activeTab === tab.label
                                        ? `
                                            bg-green-700
                                            text-white
                                            shadow-lg
                                          `
                                        : `
                                            bg-slate-100
                                            text-slate-700
                                            hover:bg-blue-50
                                            hover:text-blue-700
                                          `
                                }
                            `}
                        >

                            {tab.icon}

                            {tab.label}

                        </button>

                    ))}

                </div>

            </div>

        </div>

    );

}